
var stache = require('can/view/stache/stache');
module.exports = stache("<streaming-schedule/>\r\n");